import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConsumoInserirRoutingModule } from './consumo-inserir-routing.module';
import { ConsumoInserirComponent } from './consumo-inserir.component';
import { FormsModule } from '@angular/forms';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    ConsumoInserirComponent
  ],
  imports: [
    CommonModule,
    ConsumoInserirRoutingModule,
    FormsModule,
    TableModule,
    DialogModule,
    InputTextModule,
    DividerModule,
    MessagesModule,
    DropdownModule,
    CalendarModule,
    InputNumberModule,
    ProgressSpinnerModule
  ]
})
export class ConsumoInserirModule { }
